import { WebApiEndpoints } from '@liquitics/transaction';
import { HttpClient } from '@angular/common/http';

export async function getResponseFromJSONData(http: HttpClient, url: string, queryString: string): Promise<any> {
    if (url.endsWith(WebApiEndpoints.QueryApplicationConfigurations)) {
        return http.get('assets/demo/data/rest/application-configuration.json').toPromise();
    } else if (url.endsWith(WebApiEndpoints.QueryALMMetricData)) {
        if (queryString.includes('METRIC_TREND')) {
            return http.get('assets/demo/data/rest/metric-data-metric-trend.json').toPromise();
        } else if (queryString.includes('LADDER')) {
            return http.get('assets/demo/data/rest/metric-data-ladder.json').toPromise();
        } else if (queryString.includes('METRIC')) {
            return http.get('assets/demo/data/rest/metric-data-metric.json').toPromise();
        }
    } else if (url.endsWith(WebApiEndpoints.GetAvatar)) {
        return http.get('assets/demo/data/rest/avatars.json').toPromise();

    }
    return {};
}